<template>
  <v-card color="#d13b55" class="rounded" elevation="1">
    <v-card-text class="text-xs-center">
      <div class="white-text subheading font-weight-bold">
        <v-img
          src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-260-260.png"
          alt="Ovations Points"
          aspect-ratio="1"
          width="56"
          max-width="56"
          style="margin: 0 auto"
        ></v-img>
      </div>
      <div class="mt-2 white-text text-uppercase">Your Ovations Points</div>
      <p class="mt-2 white-text font-weight-bold display-1">
        {{ $store.state.userSelf.currentOrg.spendOvations }}
      </p>
      <div>
        <v-btn
          :disabled="
            Number($store.state.userSelf.currentOrg.spendOvations) <= 0
          "
          color="white"
          :href="$store.state.storeUrl"
          target="_blank"
          round
          small
          >REDEEM</v-btn
        >
        <v-btn
          v-if="$store.getters.shareSpendOvations"
          color="black"
          to="/shareovations"
          dark
          round
          small
          >SHARE</v-btn
        >
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OvationsPoints",
};
</script>

<style>
</style>